import { changePassword } from '../../js/api/profile.js';
import { _t } from '../../services/TranslationService.js';

let ChangePassword = {
    render: async () => {
        let view =  /*html*/`
            <div class="w-full flex flex-row flex-wrap items-center justify-center">
                <div class="w-full flex flex-row flex-wrap bg-black/40 space-x-2 items-center p-2 border-b border-[#3d3d3d]">
                    <a class="flex backBtn w-[24px] h-[24px] max-w-[calc(100%-24px)] border-r">
                        <svg class="py-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7 12" preserveAspectRatio="none"><path fill="#F8F8F8" fill-rule="evenodd" d="M6.216 12L7 11.243 1.569 6 7 .757 6.216 0 .784 5.243 0 6l.784.757z"></path></svg>
                    </a>
                    <span class="text-white text-center font-bold flex-1 text-[14px]">${_t('Ndrysho fjalekalimin')}</span>
                </div>
                <div class="flex flex-row flex-wrap w-full items-center border-b border-[#3d3d3d] justify-between py-10">

                    <div class="flex flex-wrap flex-row justify-center items-center w-full h-full">
                        <div class="flex flex-row flex-wrap w-full max-w-[360px] rounded-[2px] overflow-hidden bg-gradient-to-b from-[rgba(43,43,43,1)] to-[rgba(68,68,68,1)] shadow-[0px_3px_3px_#000000]">
                            <div class="flex flex-row flex-wrap items-center justify-center w-full bg-black mb-[10px] font-bold text-[14px] leading-[30px] text-white shadow-[0px_1px_1px_#000000]">
                                <span class="font-bold text-[14px] leading-[30px]">Regjistrohu</span>
                            </div>
                            <div class="flex flex-row flex-wrap w-full space-y-3">
                                <div class="flex flex-row flex-wrap w-full space-x-2">
                                    <span class="w-[140px] text-right text-white leading-[24px] text-[12px]">${_t('Fjalekalimi i vjeter')}:</span>
                                    <div class="flex flex-row flex-wrap flex-1">
                                        <input class="w-[150px] h-[24px] border-0 text-black rounded-[3px] bg-[#cccccc] shadow-[0px_1px_1px_1px_#000] px-2 text-[12px]" type="password" id="oldPassword">
                                    </div>
                                </div>
                                <div class="flex flex-row flex-wrap w-full space-x-2">
                                    <span class="w-[140px] text-right text-white leading-[24px] text-[12px]">${_t('Fjalekalimi i ri')}:</span>
                                    <div class="flex flex-row flex-wrap flex-1">
                                        <input class="w-[150px] h-[24px] border-0 text-black rounded-[3px] bg-[#cccccc] shadow-[0px_1px_1px_1px_#000] px-2 text-[12px]" type="password" id="newPassword">
                                    </div>
                                </div>
                                <div class="flex flex-row flex-wrap w-full space-x-2">
                                    <span class="w-[140px] text-right text-white leading-[24px] text-[12px]">${_t('Perserit Fjalekalimin')}:</span>
                                    <div class="flex flex-row flex-wrap flex-1">
                                        <input class="w-[150px] h-[24px] border-0 text-black rounded-[3px] bg-[#cccccc] shadow-[0px_1px_1px_1px_#000] px-2 text-[12px]" type="password" id="repeatPassword">
                                    </div>
                                </div>
                                <div class="flex flex-row flex-wrap w-full items-center justify-center">
                                    <button class="changePassowrdBtn bg-[rgba(0,0,0,0.4)] border border-[rgba(255,255,255,1)] text-white px-[10px] w-auto h-[30px] cursor-pointer leading-[30px] text-[12px]" id="changePassowrdBtn">${_t('Regjistro')}</button>
                                </div>
                                <div class="flex flex-row flex-wrap w-full items-center justify-center">
                                    <span class="errorDesc text-[8pt] mb-2 text-white"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
       `;
        return view;
    }
    , after_render: async () => {
        const submitBtn = document.getElementById('changePassowrdBtn');

        submitBtn.addEventListener('click', async () => {
            const old_password = document.getElementById('oldPassword').value;
            const new_password = document.getElementById('newPassword').value;
            const new_password_repeat = document.getElementById('repeatPassword').value;
            var res = await changePassword({
                new_password,
                new_password_repeat,
                old_password
            });

            if (res && res.message) {
                alert(res.message);
                $('input').val('');
            }
        });
    }

}

export default ChangePassword;